module.exports = __webpack_public_path__ + "img/Realweb.74dd4375.png";